export default __webpack_public_path__ + "static/media/inventory_subtier.f601d67c.svg";